<template>
  <div id="footer">
    <router-link to="/" class="footer_item" :class="active == 0 ? 'active' : ''">
      <div class="icon_wrap">
        <img v-if="active === 0" src="../../assets/images/tabs/home_color.png" alt="">
        <img v-else src="../../assets/images/tabs/home.png" alt="">
      </div>
      <p class="footer_info">
        {{ $t("首页") }}
      </p>
    </router-link>
    <router-link to="/activity" class="footer_item" :class="active == 1 ? 'active' : ''">
      <div class="icon_wrap">
        <img v-if="active === 1" src="../../assets/images/tabs/activity_color.png" alt="">
        <img v-else src="../../assets/images/tabs/activity.png" alt="">
      </div>
      <p class="footer_info">
        {{ $t("晋升") }}
      </p>
    </router-link>
    <router-link to="/agent" class="footer_item agent" :class="active == 2 ? 'active' : ''">
      <div class="icon_wrap">
        <img v-if="active === 2" src="../../assets/images/tabs/agent_color.png" alt="">
        <img v-else src="../../assets/images/tabs/agent.png" alt="">
      </div>
      <p class="footer_info">
        {{ $t("代理人") }}
      </p>
    </router-link>
    <div class="footer_item" :class="active == 3 ? 'active' : ''" @click="toRech">
      <div class="icon_wrap">
        <img v-if="active === 3" src="../../assets/images/tabs/wallet_color.png" alt="">
        <img v-else src="../../assets/images/tabs/wallet.png" alt="">
      </div>
      <p class="footer_info">
        {{ $t("定金") }}
      </p>
    </div>
    <router-link to="/person" class="footer_item" :class="active == 4 ? 'active' : ''">
      <div class="icon_wrap">
        <img v-if="active === 4" src="../../assets/images/tabs/personal_color.png" alt="">
        <img v-else src="../../assets/images/tabs/personal.png" alt="">
      </div>
      <p class="footer_info">
        {{ $t("个人") }}
      </p>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      isShowFt: true,
      isLogin: false
    };
  },
  created() {
    let token = localStorage.getItem("token");
    if (token) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.$bus.$on("send2ftnav", (idx) => {
      this.active = idx;
    });
  },
  methods: {
    showRegistro() {
      this.$parent.is_show_login = false;
      this.$parent.is_show_register = true;
    },
    toRech() {
      this.$parent.isShowRecharge = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";

#footer {
  position: fixed;
  height: 52px;
  bottom: 0;
  left: 50%;
  margin-left: calc(-50%);
  right: 0;
  display: flex;
  // background-color: @primary-color;
  z-index: 3;
  // width: calc(100%);
  width: 100%;
  max-width: @maxWidth;
  background-image: url("../../assets/images/tabs/menu_bg.png");
  background-position: 0 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.footer_item {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  // padding: 0.3rem 0;

  &.active .footer_info {
    color: @textcolor1;
  }

  &.active {
    .icon_wrap {
      img {
        width: 50px;
        margin-top: -10px;
      }
    }
  }

  &.agent {
    .icon_wrap {
      img {
        width: 50px;
        margin-top: -20px;
      }
    }
  }
}

.svg_icon path {
  fill: @svgColor;
}

.twoToneStroke {
  stroke: @svgColor;
}

.icon_stroke {
  fill: none !important;
  stroke: @svgColor !important;
}

.svg_icon rect,
.svg_icon circle {
  fill: @svgColor;
}

.i4 rect,
.i4 path {
  fill: transparent;
}

.white {
  fill: #fff !important;
}

.rect_svg {
  fill: none !important;
  stroke: @svgColor !important;
}

.icon_wrap {
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  svg,
  img {
    width: 30px;
    // height: 25px;
    // fill: #fff
  }
}



.ft_icon {
  font-size: 0.667rem;
  color: #8f6ae9;
}

.footer_info {
  color: @textcolor2;
  font-size: 12px;
  margin-top: 0.1rem;
}

.login_path {
  stroke: #FFFFFF;
  fill: none !important;
}


.active .ft_icon {
  font-size: 0.8rem;
  color: #c74cf9;
}

.active .footer_info {
  // color: @anttextcolor;
}

.fillSvg {
  fill: #666666;
}

.svgActive {
  fill: #E41827;
}

.fimg {
  width: 1.1rem;
  height: 1.1rem;
}
</style>